<template>
  <div class="uk-container">
    <div v-if="practice.r" class="uk-alert-warning uk-width-large uk-margin-auto" uk-alert>
      <div class="uk-text-center">
        <p>Your last request is being processed. Please allow couple of days for the request to be resolved.</p>
        <p class="uk-margin-remove-bottom">You can contact the Administrator for additional details.</p>
      </div>
    </div>

    <div class="uk-card uk-card-default uk-width-large uk-margin-auto">
      <div class="uk-card-header uk-text-center">
        <h3 class="uk-card-title">{{ practice.name }}</h3>
        <p class="uk-text-meta">Your Profile</p>
      </div>

      <div class="uk-card-body uk-text-center">
        <p>
          <b>Address</b>:<br>
          {{ practice.location.house }} {{ practice.location.street }}<br>
          {{ practice.location.city }}<br>
          {{ practice.location.postcode }}
        </p>
        <p><b>Practice</b>: {{ practice.phone.primary }}</p>
        <p><b>On-Call</b>: {{ practice.phone.secondary }}</p>
        <p><b>Area</b>: {{ $helpers.getAreaName(practice.area) }}</p>
      </div>

      <div class="uk-card-footer uk-text-center">
        <button class="uk-button uk-button-primary" :disabled="practice.r" uk-tooltip="Update Details about your Practice" @click="request">Request Update</button>
      </div>
    </div>

    <div class="uk-margin-top uk-box-shadow-large map-placeholder">
      <iframe width="100%" height="100%" :src="`https://maps.google.com/maps?q=${practice.location.geopoint.latitude},${practice.location.geopoint.longitude}+(${encodeURI(practice.name)})&z=9&output=embed`" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" style="min-height: 400px;" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewDentistPracticeView',

  computed: {
    practice() {
      return this.$store.getters['dentists/find'](this.$store.state.account.profile.dentist)
    }
  },

  methods: {
    request() {
      this.$router.push({ name: 'dentist-practice-update' })
    }
  }
}
</script>

<style lang="scss" scoped>
.map-placeholder {
  width: 100%;
  height: 100%;
  min-height: 400px;

  background-color: $colour-grey;
}
</style>
